var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.rm
      ? _c("h4", [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
          _vm._v(" Checking dependencies...\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.rm
      ? _c("div", [
          _vm.requestPages.length > 0
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                RequestPages (" +
                      _vm._s(_vm.requestPages.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.requestPages, function (p) {
                    return _c(
                      "li",
                      { key: p.Id, staticClass: "list-group-item" },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.url_EditRequestPagePage(p),
                                expression: "url_EditRequestPagePage(p)",
                              },
                            ],
                            staticClass: "text-primary",
                            attrs: { target: "_blank" },
                          },
                          [_vm._v(_vm._s(p.Name))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rm.Reports.length > 0
            ? _c("div", { staticClass: "card mt-3" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                Reports (" +
                      _vm._s(_vm.rm.Reports.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.rm.Reports, function (r) {
                    return _c(
                      "li",
                      { key: r.Id, staticClass: "list-group-item" },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: _vm.url_ReportViewPage(r),
                                expression: "url_ReportViewPage(r)",
                              },
                            ],
                            staticClass: "text-primary",
                            attrs: { target: "_blank" },
                          },
                          [_vm._v(_vm._s(r.Name))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rm.Notifications.length > 0
            ? _c("div", { staticClass: "card mt-3" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(
                    "\n                Notifications (" +
                      _vm._s(_vm.rm.Notifications.length) +
                      ")\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush" },
                  _vm._l(_vm.rm.Notifications, function (n) {
                    return _c(
                      "li",
                      { key: n.Id, staticClass: "list-group-item" },
                      [_c("span", [_vm._v(_vm._s(n.Name))])]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }